import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Dropdown, Form, Icon, Input } from 'semantic-ui-react'
import { ICountry, ManagersOptionsType } from '~/api/services/dairy'
import { FormFields } from '~/components/FormFields'
import { useAuth } from '~/routes/components/AuthProvider'
import { StyledField } from './style'
import { DateInput } from 'semantic-ui-calendar-react'
import { useParams } from 'react-router'
import { getError } from '~/components/FormFields/util'

interface Props {
  managerOptions: ManagersOptionsType
  countries: ICountry[]
}

const ManagerInfo: React.FC<Props> = ({ managerOptions, countries }) => {
  const { t } = useTranslation()
  const { control, setValue, formState: { isSubmitted } } = useFormContext()
  const { systemData: { languages, logged: { languageId } } } = useAuth()
  const languageLocal = languages.find(language => language.id === languageId)
  const { id } = useParams()

  const wathcMobileCodeField = useWatch({ control, name: 'mobilePrefix' })
  const mobileNumber = useWatch({ control, name: 'mobileNumber' })
  const watchMembershipSigned = useWatch({ control, name: 'membershipApplicationDate' })
  const watchTerminationDate = useWatch({ control, name: 'cancellationDate' })

  return <>
    <Form.Group widths={'equal'}>
      <FormFields.Input
        control={control}
        name={'firstName'}
        label={t('Manager name')}
        placeholder={t('Manager name')}
        rules={{
          required: t('Please enter first name'),
          maxLength: {
            value: 40,
            message: t('Max chart. is 40')
          }
        }}
      />
      <FormFields.Input
        control={control}
        name={'lastName'}
        label={t('Manager last name')}
        placeholder={t('Manager last name')}
        rules={{
          required: t('Please enter Manager last name'),
          maxLength: {
            value: 40,
            message: t('Max chart. is 40')
          }
        }}
      />
      <Controller
        control={control}
        name={'membershipApplicationDate'}
        rules={{
          required: {
            value: true,
            message: t('Please enter membership application date')
          }
        }}
        render={({ field, fieldState }) => {
          return <StyledField
            required
            error={!watchMembershipSigned && isSubmitted ? getError(fieldState) : false}
          >
            <label>{t('Membership signed')}</label>
            <DateInput
              name='date'
              localization={languageLocal.code}
              pickerStyle={{ width: 200 }}
              placeholder={t('Date')}
              closeOnMouseLeave={false}
              clearable
              onKeyPress={(event) => event.preventDefault()}
              dateFormat={'DD.MM.YYYY'}
              closable
              value={watchMembershipSigned || ''}
              iconPosition='left'
              onChange={(event, { name, value }) => setValue('membershipApplicationDate', value)}
            />
          </StyledField>

        }}
      />

    </Form.Group>
    <Form.Group widths={'equal'}>
      <FormFields.Input
        control={control}
        name={'agisId'}
        label={t('AGIS-ID Person')}
        placeholder={t('Please enter AGIS-ID')}
        rules={{
          required: t('Please enter AGIS-ID Person')
        }}
      />
      <FormFields.Select
        control={control}
        name={'languageId'}
        options={managerOptions?.languages?.map(language => ({ value: language.id, text: language.label }))}
        rules={{
          required: t('Select Language')
        }}
        label={t('Language MGA')}
        placeholder={t('Select Language')}
      />
      <FormFields.Input
        control={control}
        name={'burNumber'}
        label={t('BUR number')}
        placeholder={t('Enter BUR number')}
      />

    </Form.Group>
    <Form.Group widths={'equal'}>
      <FormFields.Select
        control={control}
        name={'associations'}
        multiple
        options={managerOptions?.associations?.map(association => ({ value: association.id, text: association.name }))}
        label={t('Association')}
        placeholder={t('Please select association')}
      />
      <Form.Field style={{ paddingLeft: 0 }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
          <Icon name={'mobile alternate'} style={{ fontSize: '1.2em' }} />
          <div>{t('Mobile number')}</div>
        </label>
        <Input
          value={mobileNumber || ''}
          label={<Dropdown
            scrolling
            basic
            clearable
            options={countries.map(countryCode => ({ value: countryCode.id, text: countryCode.phoneCode, flag: countryCode.iso }))}
            selectOnBlur={false}
            value={parseInt(wathcMobileCodeField) || ''}
            onChange={(e, data) => setValue('mobilePrefix', data.value)}
            placeholder={t('Code')}
            name={'mobilePrefix'}
          />}
          onChange={(e, data) => setValue('mobileNumber', data.value)}
          labelPosition='left'
          style={{ marginBottom: 10 }}
          type={'number'}
          placeholder={wathcMobileCodeField ? t('Mobile number') : t('Please select mobile code')}
          name={'mobileNumber'}
        />
      </Form.Field>
      <FormFields.Checkbox
        label={t('MGA digital?')}
        defaultValue={0}
        checkboxValue={1}
        style={{ marginTop: 30 }}
        control={control}
        name={'digitalPayment'}
      />
    </Form.Group>
    {id && <StyledField width={5} style={{ marginBottom: '1em' }}>
      <label>{t('Cancellation date')}</label>
      <DateInput
        name='date'
        localization={languageLocal.code}
        pickerStyle={{ width: 200 }}
        placeholder={t('Date')}
        closeOnMouseLeave={false}
        clearable
        onKeyPress={(event) => event.preventDefault()}
        dateFormat={'DD.MM.YYYY'}
        closable
        value={watchTerminationDate || ''}
        iconPosition='left'
        onChange={(event, { name, value }) => setValue('cancellationDate', value)}
      />
    </StyledField>}
  </>
}
export default ManagerInfo